import isPopupLogin from './isPopupLogin';

const sendPopupLoginSuccessMessage = (query) => {
  try {
    if (isPopupLogin(query)) {
      window.opener.postMessage('login-successful');
      return window.close();
    }
  } catch {
    /**/
  }
};

export default sendPopupLoginSuccessMessage;
